import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga4'
import App from './App'
import './styles/globals.css'
import { env } from '@/config/env'

if (env.gaMeasurementId) {
  ReactGA.initialize(env.gaMeasurementId)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
